"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyModifiersProvider = exports.getModifiers = exports.useKeyModifiers = exports.KeyModifierContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const defaultKeyModifiersState = {
    ctrlKey: false,
    shiftKey: false,
    altKey: false,
};
exports.KeyModifierContext = (0, react_1.createContext)(defaultKeyModifiersState);
function useKeyModifiers() {
    const context = (0, react_1.useContext)(exports.KeyModifierContext);
    if (!context) {
        throw new Error('key modifiers context was not found');
    }
    return context;
}
exports.useKeyModifiers = useKeyModifiers;
const isMac = navigator !== undefined && navigator.userAgent.toLowerCase().includes('mac');
function getModifiers(event) {
    const { shiftKey, altKey, metaKey } = event;
    const ctrlKey = isMac ? metaKey : event.ctrlKey;
    return { ctrlKey, shiftKey, altKey };
}
exports.getModifiers = getModifiers;
function KeyModifiersProvider({ children }) {
    const [modifiers, setModifiers] = (0, react_1.useState)(defaultKeyModifiersState);
    (0, react_1.useEffect)(() => {
        function handleKeyDown(event) {
            setModifiers(getModifiers(event));
        }
        function handleKeyUp(event) {
            setModifiers(getModifiers(event));
        }
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.KeyModifierContext.Provider, { value: modifiers, children: children }));
}
exports.KeyModifiersProvider = KeyModifiersProvider;
